module.exports = __webpack_public_path__ + "img/architecture.060427b9.png";